var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 120,
    viewBox: "0 0 200 120",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#25459A",
    width: 200,
    height: 120,
    rx: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.267 52.788c-.075 5.572 5.292 8.681 9.335 10.53 4.154 1.897 5.549 3.113 5.533 4.81-.032 2.595-3.313 3.741-6.385 3.786-5.36.078-8.475-1.358-10.952-2.444l-1.93 8.477c2.485 1.075 7.087 2.012 11.859 2.053 11.201 0 18.53-5.189 18.57-13.234.044-10.21-15.05-10.776-14.947-15.34.036-1.383 1.443-2.86 4.526-3.236 1.526-.19 5.74-.334 10.516 1.73l1.875-8.202c-2.568-.877-5.87-1.718-9.98-1.718-10.544 0-17.96 5.26-18.02 12.788m46.015-12.081c-2.045 0-3.77 1.12-4.538 2.838l-16.002 35.852h11.194l2.227-5.776h13.68l1.291 5.776H164l-8.61-38.69h-9.108m1.566 10.452l3.23 14.528h-8.847l5.617-14.528M86.695 40.707l-8.823 38.69H88.54l8.819-38.69H86.695m-15.78 0L59.814 67.04l-4.49-22.392c-.528-2.5-2.609-3.942-4.92-3.942h-18.15L32 41.83c3.726.759 7.96 1.983 10.524 3.292 1.57.8 2.017 1.499 2.533 3.4l8.506 30.875h11.273l17.281-38.69H70.916",
    fill: "#FFF",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.fdffe7157df71fce73a1e384150872a7.svg";
export { ForwardRef as ReactComponent };